import React,{useContext, useEffect, useState} from 'react'
import { Link,useNavigate } from 'react-router-dom'
import { context } from './ContextFun'
import Loading from "./loading.gif"

function Signin() {
  let { value, setValue, users, setUsers,isLoading,setIsLoading } = useContext(context)
  let [notCorrect,setNotCorrect] = useState("")

  let navigate = useNavigate()
  
  let handleChange = (e) => {
    setValue({...value,[e.target.name]:e.target.value})
  }

  let getUsers = async() => {
    let res = await fetch(`https://backend-todolist.vercel.app/getUsers`)
    let json = await res.json()
    return json
  }
  useEffect(() => {
    getUsers().then(res => setUsers(res))
  }, [])
  console.log(users)
  

  // console.log("findUser",findUser);
  
  let handleSubmit = (e) => {
    e.preventDefault()
    // console.log("SingedinUser",signedinUser);
    if (users.some(item => item.email === value.email && item.password === value.password)) {
        navigate("/todo")
    } else {
      setNotCorrect("E-Mail or password is not correct!")
    }
  }

  return (
    <div className='signin'>
      
      {isLoading && (
        <div className="loading">
        <img src={Loading} alt="" />
        </div>
      )}
          <h1>Welcome to your To do List <br /> Please Sign in </h1>
          <form onSubmit={handleSubmit} action="">
              <input onChange={handleChange} value={value.email} type="email" name="email" id="" placeholder='E-Mail...'/>
        <input onChange={handleChange} value={value.password} type="password" name="password" id="" placeholder='Password...' />
        <b>{ notCorrect}</b>
              <button>Sign in</button>
          </form>
          <h3>You don't have an account <Link to="/signup">Sign up</Link></h3>
    </div>
  )
}

export default Signin